import React from 'react';

const DiscountItemCard = ({ item, getLangTranslation }) => {
    const { ID, Discount, InitialParentCount, FinalParentCount } = item;
    const iconClass = {
        '10': 'pink',
        '20': 'purple',
        '30': 'blue',
        '40': 'yellow',
        '50': 'green'
    }
    return (
        <div className='col-12 col-md-6 col-lg-4 col-xxl' key={ID}>
            <div className='card border-blue-400 pt-cursor'>
                <div className='card-body '>
                    <div className='d-flex align-items-center gap-3'>
                        <span className={`icon-wrap icon-${iconClass[Discount]}`}>
                            <i className="icon-percent"></i>
                        </span>
                        <div className="flex-grow-1">
                            <h6 className='text-blue-900 mb-0 text-lowercase'>{`${Discount}% ${getLangTranslation('SETTINGS_DISCOUNT_TEXT', 'Discount')}`}</h6>
                            <p className='text-gray text-small mb-0'>{getLangTranslation('X_TO_Y_PARENTS', 'x to y parents')?.replace("x", InitialParentCount)?.replace("y", FinalParentCount)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DiscountItemCard